import { tokens } from "@blurb/codex-react";
import { keyframes } from "@emotion/react";
import { Flex } from "@rpi/openapi-core";
import React from "react";

const pulse = keyframes({ "0%, 100%": { opacity: 1 }, "50%": { opacity: 0.4 } });

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
}

/** Animated placeholder block shown while content loads. */
export const Skeleton: React.FC<SkeletonProps> = ({ width = "100%", height = 16 }) => (
  <Flex
    aria-hidden
    sx={{
      width,
      height,
      borderRadius: tokens.radius.sm,
      backgroundColor: tokens.color.semantic.bg.graySubtle,
      animation: `${pulse} 1.5s ease-in-out infinite`,
    }}
  />
);
